import React from "react";
import styles from "../../styles/landing.module.css";

const ComparisonSection = () => {
  return (
    <section className={styles.comparisonSection}>
      <h2>Why use Memory Curve?</h2>
      <div className={styles.comparisonContainer}>
        <div className={`${styles.comparisonCard} ${styles.without}`}>
          <h3>Without Memory Curve</h3>
          <ul>
            <li>Inefficient and time-consuming revisions</li>
            <li>Rapid forgetting of information</li>
            <li>Frustrating learning experience</li>
            <li>Decreasing motivation</li>
            <li>Procrastination</li>
          </ul>
        </div>
        <div className={`${styles.comparisonCard} ${styles.with}`}>
          <h3>With Memory Curve</h3>
          <ul>
            <li>Scientifically planned revisions</li>
            <li>Long-term memorization</li>
            <li>Optimized study time</li>
            <li>Measurable progress</li>
            <li>Sustained motivation</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default ComparisonSection; 